import { createTheme } from '@material-ui/core/styles';

import getPalette from './palette';
import typography from './typography';
import overrides from './overrides';
import settings from './settings';
import props from './props';

const theme = () => {
  const palette = getPalette();

  return createTheme({
    typography,
    palette,
    overrides,
    settings,
    props,
    breakpoints: {
      values: {
        mobile: 780,
        desktop: 781,
        xs: 0,
        sm: 600,
        md: 767,
        lg: 1280,
        xl: 1690,
        xxl: 1920,
      },
    },
  });
};

export default theme;



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/theme.js